import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";

import { adsApi } from "../api/ads";
import { authTokenApi } from "../api/auth-token";
import { charactersApi } from "../api/characters";
import { coinsApi } from "../api/coins";
import { courseApi } from "../api/course";
import { coursesApi } from "../api/courses";
import { exerciseApi } from "../api/exercise";
import { exerciseEntrypointApi } from "../api/exercise-entrypoint";
import { exercisesApi } from "../api/exercises";
import { userInfoApi } from "../api/user-info";

import appReducer from "./app/app.slice";

export const store = configureStore({
  reducer: {
    app: appReducer,
    [adsApi.reducerPath]: adsApi.reducer,
    [authTokenApi.reducerPath]: authTokenApi.reducer,
    [charactersApi.reducerPath]: charactersApi.reducer,
    [coinsApi.reducerPath]: coinsApi.reducer,
    [coursesApi.reducerPath]: coursesApi.reducer,
    [exerciseApi.reducerPath]: exerciseApi.reducer,
    [exercisesApi.reducerPath]: exercisesApi.reducer,
    [courseApi.reducerPath]: courseApi.reducer,
    [userInfoApi.reducerPath]: userInfoApi.reducer,
    [exerciseEntrypointApi.reducerPath]: exerciseEntrypointApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      adsApi.middleware,
      authTokenApi.middleware,
      charactersApi.middleware,
      coinsApi.middleware,
      coursesApi.middleware,
      exerciseApi.middleware,
      exercisesApi.middleware,
      courseApi.middleware,
      userInfoApi.middleware,
      exerciseEntrypointApi.middleware,
    ]),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
